import SectionHeader from '@Web/Src/Components/SectionHeader';
import { INTEGRATIONS } from '@Web/Src/constants.js';
import { assetUrl } from '@Shared/Helpers/Utilities';

function Integrations() {
    return (
        <>
            <SectionHeader
                type='dark'
                className='mt-40 max-w-lg'
                icon='puzzle'
                title={__('Fully automate your referral program using integrations')}
            />
            <div className='mt-10 flex max-w-[850px] flex-wrap justify-center gap-4'>
                {INTEGRATIONS.map((item) => {
                    return (
                        <div
                            className='flex h-[100px] w-[200px] items-center justify-center'
                            key={item}
                        >
                            <img
                                alt={item}
                                src={assetUrl(
                                    `/assets/images/svg/web/integrations/${item}.svg`
                                )}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default Integrations;
